import React, { useState } from 'react';
import { CandidatesPanel } from './Candidates/CandidatesPanel';
import { AGENTIC_PANELS, AgenticPanel } from './constants';
import { ResultsPanel } from './Results/ResultsPanel';
import { SetupPanel } from './Setup/SetupPanel';

interface AgenticAssessmentTabProps {
  jobOpeningId: string;
}

const PANEL_ICONS: Record<AgenticPanel, string> = {
  Setup: 'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z',
  Candidates: 'M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z',
  Results: 'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z',
};

export const AgenticAssessmentTab: React.FC<AgenticAssessmentTabProps> = ({ jobOpeningId }) => {
  const [panel, setPanel] = useState<AgenticPanel>('Setup');
  const [openSessionId, setOpenSessionId] = useState<string | null>(null);

  const openReport = (sessionId: string | null) => {
    setOpenSessionId(sessionId);
    if (sessionId) setPanel('Results');
  };

  return (
    <div className='flex min-h-[520px] gap-0'>
      <div className='flex w-16 shrink-0 flex-col items-center gap-2 border-r border-slate-100 bg-slate-50/70 py-4'>
        { AGENTIC_PANELS.map((p) => {
          const active = panel === p;
          return (
            <button
                key={p}
                type='button'
                onClick={() => { setPanel(p); if (p !== 'Results') setOpenSessionId(null); }}
                className={`group flex w-12 flex-col items-center gap-1 rounded-xl p-2 transition-all ${
                  active ? 'bg-emerald-600 shadow-md shadow-emerald-100' : 'hover:bg-white hover:shadow-sm'
                }`}
            >
              <svg
                  className={`h-5 w-5 ${active ? 'text-white' : 'text-slate-400 group-hover:text-emerald-600'}`}
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  strokeWidth={1.8}
              >
                <path strokeLinecap='round' strokeLinejoin='round' d={PANEL_ICONS[p]} />
              </svg>
              <span className={`text-[8px] font-bold uppercase tracking-tight ${
                active ? 'text-white' : 'text-slate-400 group-hover:text-emerald-600'
              }`}>
                { p }
              </span>
            </button>
          );
        }) }
      </div>

      <div className='min-w-0 flex-1 overflow-y-auto p-5' style={{ maxHeight: 'calc(100dvh - 160px)' }}>
        { panel === 'Setup' && <SetupPanel jobOpeningId={jobOpeningId} onGoToCandidates={() => setPanel('Candidates')} /> }
        { panel === 'Candidates' && (
          <CandidatesPanel jobOpeningId={jobOpeningId} onGoToSetup={() => setPanel('Setup')} onOpenReport={openReport} />
        ) }
        { panel === 'Results' && (
          <ResultsPanel jobOpeningId={jobOpeningId} openSessionId={openSessionId} onOpenReport={openReport} />
        ) }
      </div>
    </div>
  );
};
